// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 30 ? "23b2023c" : chunkId) + "." + {"30":"b0cbca1ef02bea40","762":"98b088495ff36fc1"}[chunkId] + ".js";
};